export default {"src":"/_next/static/media/multipleGroupsForContactlist.d60ac30a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};